function getFibreFromModelSpans({ modelSpans, hasCantilever }) {
    const mainSpans = hasCantilever ? modelSpans.slice(1, -1) : modelSpans;

    return mainSpans.map(span => {
        let item;

        if (span < 3.5) item = 0;
        else if (span < 7) item = 1;
        else if (span < 10.5) item = 2;
        else if (span < 14) item = 3;
        else if (span < 17.5) item = 4;
        else if (span < 20.5) item = 5;

        return item;
    })
}



function getType2SpanRestraints({ direction, format, modelSpans, hasCantilever }) {
    const mainSpans = hasCantilever ? modelSpans.slice(1, -1) : modelSpans;

    const spanRestraints = {
        upperFibre: [],
        lowerFibre: []
    };

    if (direction === 1) {
        //horizontal

        if (format === 1) {
            spanRestraints.upperFibre = Array(mainSpans.length).fill(0);
        } else if (format === 2) {
            spanRestraints.upperFibre = Array(mainSpans.length).fill(-1);
        }

        spanRestraints.lowerFibre = getFibreFromModelSpans({ modelSpans, hasCantilever });


    } else if (direction === 2) {
        //vertical
        // if (format === 1) {
        spanRestraints.upperFibre = Array(mainSpans.length).fill(-1);
        spanRestraints.lowerFibre = Array(mainSpans.length).fill(0);
        // }
        // else if (format === 2) {
        //     spanRestraints.upperFibre = Array(mainSpans.length).fill(1);
        //     spanRestraints.lowerFibre = getFibreFromModelSpans({ modelSpans, hasCantilever });
        // }

    }

    return spanRestraints;
}


function patchSpanRestraints(spanRestraints, { type, direction, format, modelSpans, hasCantilever }) {
    if (type === 2) {
        return getType2SpanRestraints({ direction, format, modelSpans, hasCantilever })
    } else {
        return spanRestraints;
    }
}

function patchDeformationLimit(deformationLimit, { type }) {
    if (type === 3) {
        return 250;
    }

    return deformationLimit;
}


export default {
    getFibreFromModelSpans,
    getType2SpanRestraints,
    patchSpanRestraints,
    patchDeformationLimit
}